import { useEffect, useRef, useState } from 'react'
import type { LottiePlayer } from 'lottie-web/build/player/lottie_light.min'
import { LottieProps } from './types'

const LottieAnimation = ({ animationData, autoplay, isPlaying }: LottieProps) => {
  // REFS
  const element = useRef<HTMLDivElement>(null)
  const lottieInstance = useRef<any>(null)

  // LOCAL STATE
  const [lottie, setLottie] = useState<LottiePlayer | null>(null)

  /**
   * dynamically import Lottie-web package on load
   */
  useEffect(() => {
    import('lottie-web/build/player/lottie_light.min').then((Lottie) => setLottie(Lottie.default))
  }, [])

  /**
   * applies the animation to the element ref
   */
  useEffect(() => {
    if (lottie && animationData && element.current) {
      lottieInstance.current = lottie.loadAnimation({
        path: animationData,
        container: element.current,
        autoplay,
        renderer: 'svg'
      })

      return () => {
        lottie.destroy()
      }
    }
  }, [animationData, lottie])

  /**
   * Controls the play and stop of the animation on hover
   */
  useEffect(() => {
    if (isPlaying && lottieInstance.current) {
      lottieInstance.current.play()
    }

    if (!isPlaying && lottieInstance.current) {
      lottieInstance.current.goToAndStop(0)
    }
  }, [isPlaying])

  return <div ref={element} style={{ height: '100%', width: '100%' }} />
}

export default LottieAnimation
